/** @file PadletSpeechBubbleTool */
// Original file: https://github.com/tldraw/tldraw/blob/579166a0e092a5ba49df40b684173e81f359751b/packages/tldraw/src/lib/shapes/geo/GeoShapeTool.ts
import { BaseBoxShapeTool } from 'tldraw'

export class PadletSpeechBubbleTool extends BaseBoxShapeTool {
  static override id = 'padlet-speech-bubble'
  static override initial = 'idle'
  override shapeType = 'padlet-speech-bubble'
}
